export default  {
    name: 'FLL',
    src: require('../../assets/fll/robot.png'),
    alt: 'Robô de FLL',
    button: {
        text: 'Jogar FLL',
    }
}